import { Button, Loading, Modal } from "@/components/atoms";
import { useRemoveAccessMutation } from "@/redux/apis/assistants/assistantsApi";
import { AccessLink } from "@/redux/apis/assistants/types";
import { addToast } from "@/utils";

interface RemoveMyAccessModalProps {
  link: AccessLink | null;
  open: boolean;
  onClose: () => void;
  onRemoved: () => void;
}

/** EA confirm modal — removes the EA's own access to a managed client (DELETE the link). */
export const RemoveMyAccessModal = ({ link, open, onClose, onRemoved }: RemoveMyAccessModalProps) => {
  const [removeAccess, { isLoading }] = useRemoveAccessMutation();

  const handleRemove = async () => {
    if (!link) return;
    try {
      await removeAccess(link.id).unwrap();
      addToast("success", `Removed your access to ${link.party.name}`);
      onRemoved();
      onClose();
    } catch {
      addToast("danger", "Failed to remove access. Please try again.");
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      variant="web-small"
      title="Remove My Access"
      description={`Are you sure you want to remove ${
        link?.party.name ?? "this client"
      } from your managed accounts? You will no longer have access to manage their account.`}
      renderButtons={() => (
        <>
          <Button variant="secondary" size="lg" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="custom"
            size="lg"
            className="bg-danger text-white hover:bg-danger-dark"
            onClick={handleRemove}
            disabled={isLoading}
          >
            Remove
          </Button>
        </>
      )}
    >
      {isLoading && <Loading />}
    </Modal>
  );
};
